import { createContext, useContext, useEffect } from "react";
import { DEFAULT_LOCALE, isLocale, translate, pickText, type I18nText, type Locale, type MessageKey } from "@artlove365/shared";
import { useRouter } from "./router";

const I18nCtx = createContext<Locale>(DEFAULT_LOCALE);

export function I18nProvider({ locale, children }: { locale: Locale; children: React.ReactNode }) {
  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = translate(locale, "meta.title");
    document.querySelector('meta[name="description"]')?.setAttribute("content", translate(locale, "meta.description"));
  }, [locale]);
  return <I18nCtx.Provider value={locale}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const locale = useContext(I18nCtx);
  return {
    locale,
    t: (key: MessageKey) => translate(locale, key),
    tx: (text: I18nText) => pickText(text, locale),
    /** Build a localized href: href("/gallery") → "/vi/gallery". */
    href: (path = "") => `/${locale}${path}`,
  };
}

/** Locale from the first URL segment. */
export function useUrlLocale(): Locale | null {
  const { loc } = useRouter();
  const seg = loc.pathname.split("/")[1];
  return isLocale(seg) ? seg : null;
}
